/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {},
  ERROR: {
    FETCH_ATTACHMENTS: 'Hanki liitetiedostot'
  },
  HEADER: {
    DATE: 'Päivämäärä',
    SENT_BY_F: 'Toimittanut',
    TITLE: 'Otsikko'
  },
  LABEL: {
    ATTACHMENTS: 'Liitteet',
    DATE: 'Päivämäärä',
    DETAIL: 'Yksityiskohdat',
    MESSAGE: 'Viesti',
    NO_ROWS_COMMUNICATIONS: 'Ei viestintää',
    SENT_BY_F: 'Toimittanut',
    TITLE: 'Otsikko',
    UNREAD: 'Lukematon'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
